import { Box, Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(1),
}))

export const SinglePollTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h1.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(4),
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 400,
  width: '320px',
  textAlign: 'center',
}))

export const Subtitle2 = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: 700,
  color: theme.colors.neutral.darkGray,
}))

export const Title2 = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(3),
  color: theme.colors.neutral.black,
  marginTop: theme.spacing(2),
}))

export const Attendees = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: 400,
  marginBottom: theme.spacing(2),
  color: theme.colors.neutral.darkGray,
}))

export const BarChartContainer = styled(Stack)(({ theme }) => ({
  spacing: 2,
  alignContent: 'center',
}))

export const ResultsContainer = styled(Box)(({ theme }) => ({
  padding: '24px 16px',
  borderRadius: theme.spacing(1),
}))

export const AnswerAndCountLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
}))

export const NavLinkText = styled('span')(({ theme }) => ({
  color: theme.colors.primary.slalomBlue,
  cursor: 'pointer',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
}))

export const PollCounterText = styled('span')(() => ({
  fontWeight: 500,
  fontSize: '16px',
}))

export const PushedInfo = styled(Box)(() => ({
  marginBottom: '8px',
}))

export const PushedDate = styled('div')(() => ({
  fontSize: '14px',
  color: '#999',
}))

export const SinglePollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}))

export const PollCreatedDate = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.colors.neutral.darkGray,
}))

export const PollQuestion = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 700,
  fontStyle: 'italic',
}))

export const NavLinkAllPolls = styled(Typography)(({ theme }) => ({
  color: theme.colors.primary.slalomBlue,
  cursor: 'pointer',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(5),
}))
